const BUTTON_SPINNER_TEMPLATE = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
const BUTTON_INNER_WRAPPER_TEMPLATE = '<span class="text-transparent"></span>';
export const showButtonLoader = ($button) => {
    $button
        .wrapInner(BUTTON_INNER_WRAPPER_TEMPLATE)
        .prepend(BUTTON_SPINNER_TEMPLATE)
        .addClass('loading')
        .prop('disabled', true);
};
export const hideButtonLoader = ($button) => {
    $button.find('.spinner-border').remove();
    $button.children().contents().unwrap();
    $button.prop('disabled', false).removeClass('loading');
};
export const toggleButtonLoader = ($button, state) => {
    if (state) {
        showButtonLoader($button);
    }
    else {
        hideButtonLoader($button);
    }
};
